import { FeedbackDialog } from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";

type Props = {
  onClose: () => void;
};

export function ApplicationLockedPopup(props: Props) {
  const formatMessage = useFormatMessage();

  return (
    <FeedbackDialog
      ariaLabelMessageForCloseIcon={formatMessage("Modal.closeButton")}
      type="warning"
      title={formatMessage("Application.locked.warning.title")}
      cta={{
        label: formatMessage("Application.locked.warning.close"),
        action: props.onClose,
      }}
    />
  );
}
